function SkeletonAlertsButtons({ count = 3 }) {
    return (
        <div className="flex flex-row gap-[15px] animate-pulse">
            {Array.from({ length: count }).map((_, idx) => {
                let width = 120
                if (idx === 0) width = 137
                else if (idx === 1) width = 192
                else if (idx === 2) width = 278
                return <div key={idx} className="rounded-[10px] h-[69px] min-w-[137px] max-w-[278px] w-full bg-deepPurple animate-pulse opacity-50" style={{ width }} />
            })}
        </div>
    )
}

export default SkeletonAlertsButtons
